import type { AudioCaptureOptions } from 'livekit-client';

import { VITE_DISABLE_BROWSER_NOISE_SUPPRESSION } from './environments';

/**
 * Microphone constraint overrides for anything that captures the caller.
 *
 * Empty unless VITE_DISABLE_BROWSER_NOISE_SUPPRESSION=true at build time, so
 * the browser keeps suppressing by default and this can be rolled out per
 * environment.
 *
 * Browser noise suppression strips the 2-4 kHz consonant energy speech
 * recognition needs. On a measured web call it left under 2% of the signal
 * above 1 kHz, and the agent transcribed "hello" as "No" — the /h/ and /l/ that
 * separate the two words live in exactly the band it removed. Denoising belongs
 * agent-side, where it does not sit in front of the recognizer; note that it is
 * opt-in there (NOISE_CANCELLATION_ENABLED, or the per-agent tool), so enabling
 * this flag without that leaves a call with no denoising at all.
 *
 * voiceIsolation is a second suppression stage that LiveKit also enables by
 * default, so leaving it on would undo this.
 *
 * echoCancellation and autoGainControl are untouched either way: echo
 * cancellation is needed for speakerphone, and the gain behaviour has not been
 * assessed.
 */
export const CALLER_AUDIO_CAPTURE: AudioCaptureOptions = VITE_DISABLE_BROWSER_NOISE_SUPPRESSION
  ? { noiseSuppression: false, voiceIsolation: false }
  : {};
